<div class="rt-split">
  <app-auth-brand-panel></app-auth-brand-panel>
  <div class="rt-login-col">
    <div class="rt-login-form">
      <h2 class="rt-title">{{ 'compliance.reset_password.reset_password' | translate }}</h2>

      <form #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)">
        <div class="rt-field">
          <ejs-textbox class="rt-input" [(ngModel)]="email" name="loginusername" [placeholder]="'compliance.reset_password.mail_id' | translate"
            required email #emailInput="ngModel"></ejs-textbox>
          <div class="rt-validation"
            *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched || loginForm.submitted)">
            <span *ngIf="emailInput.errors?.['required']">{{ 'compliance.reset_password.please_enter_email_id' | translate }}</span>
            <span *ngIf="emailInput.errors?.['email']">{{ 'compliance.reset_password.invalid_email_id' | translate }}</span>
          </div>
        </div>

        <button ejs-button type="submit" class="rt-btn-primary">{{ 'compliance.reset_password.submit' | translate }}</button>
      </form>

      <div class="rt-backlink" (click)="closePopup()">
        <span class="rt-link">{{ 'compliance.reset_password.click_here_to_go_back' | translate }}</span>
      </div>
    </div>
  </div>
</div>

<app-alert-popup *ngIf="alertData.alertVisible === 'success'" [Data]="alertData" (confirm)="closeAlert()"
  (close)="closeAlert()"></app-alert-popup>
